module.exports = __webpack_public_path__ + "static/4-9ce66e5375bbf601fa76e287638d068e.png";